/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// utils
import PublishSubscribeUtils from "utils/publish-subscribe-utils/PublishSubscribeUtils.js";
import UuidUtils from "utils/uuid-utils/UuidUtils.js";
import ValidationUtils from "utils/validation-utils/ValidationUtils.js";

// constants
const DEFAULT_DURATION = Number("5");

class NotificationUtils {
  static notifications = [];
  static topicId = PublishSubscribeUtils.createTopic({ name: "NotificationUtils" });

  /**
  * @param {String} message
  * @param {String} type
  * @param {Number} duration
  * @returns {String}
  */
  static publish(message, type, duration) {
    const notificationId = UuidUtils.uuid(NotificationUtils.notifications.map((i) => i.id));
    const notification = {
      duration: ValidationUtils.number(duration) ? Number(duration) : Number(DEFAULT_DURATION),
      id: notificationId,
      type: ValidationUtils.notificationType(type) ? String(type) : "primary",
      message,
    };
    NotificationUtils.notifications.push(notification);
    PublishSubscribeUtils.publish(NotificationUtils.topicId, notification);
    return notificationId;
  }

  /**
  * @param {Function} onNotification
  * @returns {String}
  */
  static subscribe(onNotification) {
    return PublishSubscribeUtils.subscribe(NotificationUtils.topicId, onNotification);
  }

  /**
  * @param {String} subscriberId
  */
  static unsubscribe(subscriberId) {
    PublishSubscribeUtils.unsubscribe(NotificationUtils.topicId, subscriberId);
  }

}
export default NotificationUtils;
